export class Variant {
    constructor(item_variant) {
        this.id = item_variant.id;
        this.image = item_variant.image;
        this.name = item_variant.name;
        this.description = item_variant.description;
        this.price = item_variant.price;
        this.status = item_variant.status;
    }
}